module.exports = __webpack_public_path__ + "static/media/cover-landing-page.8537f6c6.png";